import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const CategoryList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const filters = ['All Records'];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  const source = {
    url: "Vyapar/Category/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  useEffect(() => {
    updateMainHeader('Category');
  })

  breadCrumbsStore.updateBreadCrumbs([
    { 'Category List': '/category/list' },
  ]);

  const handleFilter = (value: any) => {
    let soureFilter: any = {
      url: "Vyapar/Category/search",
      page: 1,
      pageSize: 10,
      filter: [
      ],
      sort: [
        {
          "field": "UpdatedAt",
          "direction": "desc"
        }
      ],
    }
    switch (value) {
      case 'In Stock':
        soureFilter.filter = [{
          "field": "name",
          "operator": "eq",
          "value": "In Stock"
        }]
        break

    }
  }


  const handleAction = (action: string, row: { customerName: string, id: number }) => {

    if (action === "Edit") {
      navigate(`/category/edit/${row.id}`);
    } else if (action === "Delete") {
      setSelectedId(row.id);
      setPopupOpen(true);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "categoryName",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: handleAction,
    },
  ];

  const handleClick = () => {
    navigate("/category/create");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
         
        <Grid item xs={12}>
          <WSDataGrid
            id="categoryGrid"
            title="Category"
            columns={columns}
            source={source}
            searchBox={{ fieldName: 'categoryName' }}
            addButton={{ label: "Add New Category", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>

        <ConfirmationPopup
          type="DELETE"
          apiUrl="Vyapar/Category"
          id={selectedId}
          confirmMessage="Are you sure you want to delete this category?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("categoryGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.message, "error");
            }
          }}
        />

      </Grid>
    </Grid>
  );
});
